import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import BirthdayField from '../../common/components/BirthdayField';
export default class ChangeBirthdayModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.birthday = Stream(this.attrs.user.birthday() || '');
  }
  className() {
    return 'ChangeBirthdayModal Modal--small';
  }
  title() {
    return app.translator.trans('datlechin-birthdays.forum.change_birthday.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m(BirthdayField, {
      stream: this.birthday,
      disabled: this.loading
    }), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('datlechin-birthdays.forum.change_birthday.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    const birthday = this.birthday() || null;
    if (birthday === (this.attrs.user.birthday() ?? null)) {
      this.hide();
      return;
    }
    this.loading = true;
    this.alertAttrs = null;
    this.attrs.user.save({
      birthday
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(() => this.hide(), this.loaded.bind(this));
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/ChangeBirthdayModal', ChangeBirthdayModal);